import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface LoginState {
  isLoggedIn: boolean;
  session: object | null;
}

const initialState: LoginState = {
  isLoggedIn: false,
  session: null,
};

const loginSlice = createSlice({
  name: "login",
  initialState,
  reducers: {
    login(state, action: PayloadAction<object>) {
      state.isLoggedIn = true;
      state.session = action.payload;
    },
    logout(state) {
      state.isLoggedIn = false;
      state.session = null;
    },
  },
});

export const { login, logout } = loginSlice.actions;
export default loginSlice.reducer;
